(function (angular) {
    angular.module('bizPartEngage').service('modules.blog.service', blogService);

    blogService.$inject = ["$http"];

    function blogService($http) {
    	this.GetBlogEntries = function () {
    		return $http.get(siteRootPath + "api/BlogUser/GetBlogPostsForUser");
    	};

		this.GetRelatedBlogPosts = function (relatedToId) {
			return $http.get(siteRootPath + "api/BlogUser/GetRelatedBlogPosts", {
				params: {
					relatedToId: relatedToId
				},
				ignoreLoadingBar: true
			}, {
    			headers: {
    				IgnoreLoader: true
    			}
    		});
        };

        this.GetEntryUrlRewriteById = function (id) {
            return $http.get(siteRootPath + "api/BlogUser/GetEntryUrlRewriteById", {
                params: {
                    id: id
                }
            });
        }

    	this.GetOneBlogEntry = function (id, preview) {
    		return $http.get(siteRootPath + "api/BlogUser/GetBlogPost", {
    			params: {
                    id: id,
                    preview: preview || false
    			}
    		});
    	}

    	this.GetOneBlogEntryByTitle = function (title) {
    		return $http.get(siteRootPath + "api/BlogUser/GetBlogPostByTitle", {
    			params: {
    				title: title
    			}
    		});
    	}

    	this.AddLikeActionToBlogEntry = function (entryId, actionId) {
			return $http.post(siteRootPath + 'api/BlogUser/AddLikeActionToBlogEntry', { objectId: entryId, actionId: actionId }, { ignoreLoadingBar: true });
    	}

    	this.AddBlogComment = function (comment, entryId, parentId) {
    	    return $http.post(siteRootPath + 'api/BlogUser/AddBlogComment', {Comment: comment, ObjectId: entryId});
    	}

    	//this.DeleteBlogComment = function (commentId) {
    	//    return $http.get(siteRootPath + 'api/BlogAdmin/DeleteBlogComment', {
    	//        params: {
    	//            commentId: commentId
    	//        }
    	//    });
    	//};

    	this.GetRelatedEntries = function (entryId, pageSize, pageIndex, overrideCache) {
    		return $http.post(servicePath + 'GetBlogPostsByRelatedEntryLoggedInUser', {
    			entryId: entryId,
    			pageSize: pageSize,
    			pageIndex: pageIndex,
    			overrideCache: overrideCache
    		}, {
    			headers: {
    				IgnoreLoader: true
    			}
    		});
    	}
    	this.GetEntriesByTags = function (tagIds, pageIndex, pageSize, overrideCache, ignoreLoader) {
    		return $http.post(servicePath + 'GetBlogPostsByTagsForLoggedInUser', {
    			tagIds: tagIds,
    			pageIndex: pageIndex,
    			pageSize: pageSize,
    			overrideCache: overrideCache
    		}, {
    			headers: {
    				IgnoreLoader: ignoreLoader || false
    			}
    		});
        }

        const GetBlogEntriesByOrder = (pageIndex, overrideCache, ignoreLoader, tagIds, pageSize, order, categoryIds) => {
            var parameters = {
                tagIds: tagIds,
                order: order,
                pageIndex: pageIndex,
                overrideCache: overrideCache,
                updateLatest: true,
                pageSize: pageSize,
                categoryIds: categoryIds
            }
            return $http.post('api/BlogUser/GetBlogPostsInOrderForLoggedInUser', parameters, {
                headers: {
                    IgnoreLoader: ignoreLoader || false
                }
            });
        }

    	this.GetNewestBlogEntries = function (pageIndex, overrideCache, ignoreLoader, tagIds, pageSize, categoryIds) {
            return GetBlogEntriesByOrder(pageIndex, overrideCache, ignoreLoader, tagIds, pageSize, 0, categoryIds)
        }

        this.GetBlogEntriesByJourneyOrder = function (pageIndex, overrideCache, ignoreLoader, tagIds, pageSize) {
            return GetBlogEntriesByOrder(pageIndex, overrideCache, ignoreLoader, tagIds, pageSize, 5)
        }        

    	this.GetTag = function (id) {
    		return $http.get(siteRootPath + "api/generictag/getTags?" + $.param({ tagIds: id }));
    	}

    	this.GetTagBySystemName = function (systemName) {
    		return $http.get(siteRootPath + "api/generictag/getTagBySystemName?" + $.param({ tagSystemName: systemName }));
		};
		
		this.GetBlogPosts = function(ids) {
			return $http.post(siteRootPath + "api/BlogUser/GetBlogPosts", {
    			SpecificIds: ids
    		});
		};

		this.GetMostCommentedPosts = function(limit) {
			return $http.post(siteRootPath + "api/BlogUser/GetBlogPosts", {
				Order: 4,
				PageSize: limit,
				PageIndex: 0,
				UseComments: true
    		});
		};

		this.GetMostLikedPosts = function(limit) {
			return $http.post(siteRootPath + "api/BlogUser/GetBlogPosts", {
				Order: 2,
				PageSize: limit,
				PageIndex: 0,
    		});
		};
    }
})(window.angular);
